import React, { useState } from "react";

import Routes from "../routes";
import toast from "react-hot-toast";

const useChangePassword = ({ currentPassword, newPassword, confirmPassword }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [passwordError, setPasswordError] = useState(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState(null);
  const [currentPasswordError, setCurrentPasswordError] = useState(null);

  const validate = async () => {
    let isValid = true;
    setPasswordError(null);
    setConfirmPasswordError(null);
    setCurrentPasswordError(null);

    if (!currentPassword) {
        setCurrentPasswordError("Password cannot be empty");
        isValid = false;
    }

    if (!newPassword) {
      setPasswordError("Password cannot be empty");
      isValid = false;
    }

    if (newPassword !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match");
      isValid = false;
    }

    if (newPassword && newPassword.length < 8) {
      setPasswordError("Password must be at least 8 characters");
      isValid = false;
    }

    if (newPassword && /[A-Z]/.test(newPassword) === false) {
      setPasswordError("Password must have at least 1 capital letter");
      isValid = false;
    }

    if (
      newPassword &&
      /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(newPassword) === false
    ) {
      setPasswordError("Password must have at least 1 special character");
      isValid = false;
    }

    return isValid;
  };

  const changePassword = async (userId) => {
    setIsLoading(true);
    const isValid = await validate();

    if (!isValid) {
      setIsLoading(false);
      return;
    }

    if (!userId) {
      setIsLoading(false);
      toast.error("user id is missing!", { duration: 6000 });
      return;
    }

    try {
      const response = await fetch(Routes.Account.ChangePasswordMyProfile(), {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Id: userId,
          NewPassword: newPassword,
          ConfirmPassword: confirmPassword,
          CurrentPassword: currentPassword,
        }),
      });

      if (response.status === 200) {
        toast.success("The password has been successfully changed.", { duration: 6000 });
        return true;
      }

      toast.error("Something went wrong!", { duration: 6000 });
    } catch (error) {
      toast.error("Something went wrong!", { duration: 6000 });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const resetStates = () => {
    setPasswordError(null);
    setConfirmPasswordError(null);
    setCurrentPasswordError(null);
  }

  return {
    isLoading,
    passwordError,
    confirmPasswordError,
    currentPasswordError,
    resetStates,
    changePassword,
  };
};

export default useChangePassword;
